export default class Kid {
  constructor(data = {}) {
    this.uniqueId = data.uniqueId;
    this.name = data.name;
    this.dateOfBirth = data.dateOfBirth;
  }
}
